import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AurFormControl } from '../../models/form-control.model';

@Component({
  selector: 'aur-dropdown',
  template: `<mat-form-field [formGroup]="formGroup" fxFlex>
    <span *ngIf="control.prefix" matPrefix>{{ control.prefix }}</span>

    <mat-select
        [formControlName]="control.name"
        [placeholder]="control.placeholder"
        disabled="{{ control.isReadonly }}">

        <mat-option *ngFor="let item of dropdownValues" [value]="item.key">
            {{item.value}}
        </mat-option>

    </mat-select>

    <span *ngIf="control.suffix" matSuffix>{{ control.suffix }}</span>
</mat-form-field>`
})
export class DropdownComponent implements OnInit {

  @Input() formGroup: FormGroup;
  @Input() control: AurFormControl;
  @Input() component: Component;

  dropdownValues: Array<{ key: any, value: string }> = [];

  ngOnInit(): void {
    const methodName = 'get' + this.control.name.charAt(0).toUpperCase() + this.control.name.slice(1) + 'DropdownValues';

    this.component[methodName]()
      .subscribe(
        (values: Array<{ key: any, value: string }>) => {
          this.dropdownValues = values;

          if (this.control.value !== '') {
            if (values.some((value) => value.key === this.control.value)) {
              this.control.setValue(this.control.value);
            } else {
              this.control.setValue('');
            }
          }
        },
        error => console.error(methodName, error)
      );
  }
}
